var React = require('react');

function Previous (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"19","y1":"12","x2":"5","y2":"12","key":0}),React.createElement("polyline",{"points":"12 19 5 12 12 5","key":1})]);
}

Previous.defaultProps = {"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = Previous;

Previous.default = Previous;
